export default "__VITE_ASSET__BS4i1gr0__"